const useSubdomain = () => {
  const host = window.location.host.split('.')
  const isAdminSubdomain = host.length > 1 && host[0] === 'admin'
  const subdomain = host.length > 1 && host[0] !== 'admin' ? host[0] : undefined

  return { host, isAdminSubdomain, subdomain }
}

export default useSubdomain
